import { createLinkComponent } from '@tager/web-components';

const Link = createLinkComponent();

export default Link;
